import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../AuthContext";
import { consumePendingAuthRedirect } from "../utility/pendingAuthRedirect";

// Resumes an interrupted MCP authorise journey after login. Supabase-hosted
// login round trips (Google OAuth, email confirmation links) can land the
// signed-in user on the homepage instead of /login?redirect_url=..., so this
// watches for a session anywhere in the app and returns the user to the
// authorise screen stored by McpAuthorize.
export default function PendingAuthRedirect() {
  const { session } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!session) return;
    const target = consumePendingAuthRedirect();
    if (!target) return;
    const current = `${location.pathname}${location.search}${location.hash}`;
    if (current !== target) {
      navigate(target, { replace: true });
    }
  }, [session, navigate, location]);

  return null;
}
